<aslib-title Text="Home" SubText="" Icon="fa fa-home"></aslib-title>

<div class="card-block">

  <h4>Bem vindo ao GPA </h4>
  <p> Projeto Integrado: {{projetoIntegrado}}</p>
  
  
</div>



// WEBPACK FOOTER //
// ./src/app/home/home.component.html